export default "__VITE_ASSET__da59e658__"